<template>
  <div class="form_container">
    <form @submit.prevent="submitForm">
      <div class="auth-form-container">
        <h2>Registration</h2>
        <div class="block-input">
          <InputCustom
            v-model.trim="emailForm"
            :type="'text'"
            :className="{
              // error: email && !isEmailValid,
              required: isEmailValid === false,
              valid: isEmailValid,
            }"
            :placeholder="'Enter your email'"
          />
          <InputCustom
            v-model.trim="password"
            :type="'password'"
            :className="{
              // error: password && !isPasswordValid,
              required: isPasswordValid === false,
              valid: isPasswordValid,
            }"
            :placeholder="'Enter your password'"
          />
          <InputCustom
            v-model.trim="confirmPassword"
            :type="'password'"
            :className="{
              // error: confirmPassword && !isConfirmPasswordValid,
              required: isConfirmPasswordValid === false,
              valid: isConfirmPasswordValid,
            }"
            :placeholder="'Enter your password'"
          />

          <div class="error-message" v-if="this.errorRegister">
            {{ errorRegister }}
          </div>
        </div>
        <div class="col-12 py-2">
            <ButtonWithLoading
              class="w-100"
              title="Send"
              :isLoading="isLoading"
              type="submit"
            />
          </div>
      </div>
    </form>
    <div class="switch-form">
      <span class="switch-text">Already have an account?</span>
      <button class="switch-button" @click="switchToLogin">Login</button>
    </div>
  </div>
</template>

<script>
import { DataService } from "../../../config/dataService";
import store from "../../../vuex/store";
import InputCustom from "../InputCustom.vue";
import ButtonWithLoading from "../ButtonWithLoading.vue";

export default {
  name: "RegistrationForm",
  components: {
    InputCustom,
    ButtonWithLoading,
  },
  data() {
    return {
      email: "",
      password: "",
      confirmPassword: "",
      isEmailValid: false,
      isPasswordValid: false,
      isConfirmPasswordValid: false,
      errorRegister: "",
    };
  },
  props: {
    emailForm: String,
    emailFormValue: String,
  },
  computed: {
    isLoading() {
      return store?.getters.isLoading;
    },
  },
  methods: {
    switchToLogin() {
      this.$emit("switchMode");
    },
    validateEmail() {
      const emailRegex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.isEmailValid = emailRegex.test(this.emailForm);
    },
    validatePassword() {
      const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\W]{8,}$/;
      this.isPasswordValid = passwordRegex.test(this.password);

      // if (!this.isPasswordValid) {
      //   clearTimeout(this.passwordValidationTimeout);
      //   this.passwordValidationTimeout = setTimeout(() => {
      //     this.debouncedNotify();
      //   }, 1000);
      // } else {
      //   clearTimeout(this.passwordValidationTimeout);
      // }
    },
    validatePasswordMatch() {
      this.isConfirmPasswordValid = this.confirmPassword === this.password;

      // if (!this.isConfirmPasswordValid) {
      //   clearTimeout(this.passwordMatchTimeout);
      //   this.passwordMatchTimeout = setTimeout(() => {
      //     this.$notifications.notify({
      //       message: `<span>Passwords do not match</span>`,
      //       icon: "nc-icon nc-simple-remove",
      //       horizontalAlign: "right",
      //       verticalAlign: "top",
      //       type: "danger",
      //     });
      //   }, 1000);
      // } else {
      //   clearTimeout(this.passwordMatchTimeout);
      // }
    },
    isValid() {
      return (
        this.isEmailValid && this.isPasswordValid && this.isConfirmPasswordValid
      );
    },

    async submitForm() {
      if (!this.isPasswordValid) {
        this.$notifications.notify({
          message: `<span>Password must contains at least: 8 characters, 1 number, 1 lowercase and 1 uppercase letters and 1 special symbol</span>`,
          icon: "nc-icon nc-simple-remove",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      } else if (!this.isConfirmPasswordValid) {
        this.$notifications.notify({
          message: `<span>Passwords do not match</span>`,
          icon: "nc-icon nc-simple-remove",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
      }
      if (this.isValid()) {
        try {
          console.log(this.emailForm);
          const data = {
            email: this.emailForm.toLowerCase(),
            password: this.password,
          };
          this.errorRegister = "";
          store.dispatch("startLoading");
          const res = await DataService.post("users/register", data);
          if (!res.data || !res.data.status) {
            this.$notifications.notify({
              message: `<span>Error</span>`,
              icon: "nc-icon nc-simple-remove",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger",
            });
          }
          this.$emit("switchToVerify");
        } catch (e) {
          if (e.response.data.errorCode === 103) {
            this.errorRegister = "Email is already used";
          }
        } finally {
          store.dispatch("endLoading");
        }
      }
    },
    // debouncedNotify: _.debounce(function () {
    //   this.$notifications.notify({
    //     message: `<span>Password must contains at least: 8 characters, 1 number, 1 lowercase and 1 uppercase letters and 1 special symbol</span>`,
    //     icon: "nc-icon nc-simple-remove",
    //     horizontalAlign: "right",
    //     verticalAlign: "top",
    //     type: "danger",
    //   });
    // }, 0),
  },

  watch: {
    emailForm() {
      this.validateEmail();
    },
    password() {
      this.validatePassword();
    },
    confirmPassword() {
      this.validatePasswordMatch();
    },
  },
};
</script>

<style scoped lang="scss">
.text-btn {
  font-size: 18px;
}
</style>
